import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import EducacaoService from '../../../../../services/contasEducacao-auth';



const DepesaEducacao = () => {
    const [fonte, setFonte] = useState("");
    const [credor, setCredor] = useState("");
    const [objeto, setObjeto] = useState("");
    const [data, setData] = useState("");
    const [valor, setValor] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const despesa = await EducacaoService.cadastroDespesa({
                fonte: fonte,
                valor: valor,
                objeto: objeto,
                credor: credor,
                data: data
            })
            if (despesa.data["_id"]) {
                alert("Despesa cadastrada com sucesso!")
                setSucesso(true);
            }
            else {
                alert(despesa.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setFonte("");
        setObjeto("");
        setData("");
        setCredor("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="fonte">
                                <FloatingLabel
                                    label="Fonte"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="fonte"
                                        value={fonte}
                                        onChange={e => setFonte(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Data">
                                <FloatingLabel
                                    label="Data"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="data"
                                        value={data}
                                        onChange={e => setData(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="credor">
                                <FloatingLabel
                                    label="Credor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="credor"
                                        value={credor}
                                        onChange={e => setCredor(e.target.value)} 
                                        />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="objeto">
                                <FloatingLabel
                                    label="Objeto"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="objeto"
                                        value={objeto}
                                        onChange={e => setObjeto(e.target.value)} 
                                        as="textarea"
                                        rows={3}
                                        />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/educacao/despesas'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Despesa cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <Link to={'/restrito/educacao/despesas/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Despesas
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/educacao/despesas'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default DepesaEducacao;